import { useSuspenseQuery } from '@tanstack/react-query'

import { RoomAvailableWeeksParams, roomQueries } from '@/entities/room'

type Props = RoomAvailableWeeksParams & {
  enabled?: boolean
}

export const useRoomAvailableWeeks = ({
  roomId,
  startDate,
  isExtend,
  enabled = true,
}: Props) => {
  const { data } = useSuspenseQuery({
    ...roomQueries.roomAvailableWeeks({
      roomId,
      startDate,
      isExtend,
    }),
    ...(!enabled && {
      queryFn: () => ({ minAvailableWeeks: 0, maxAvailableWeeks: 0 }),
    }),
    meta: {
      useCustomHandling: true,
    },
  })

  if (!enabled) {
    return {
      roomAvailableWeeks: null,
    }
  }

  return {
    roomAvailableWeeks: data,
  }
}
